import React, {
  Component
} from 'react';
import {
  Button,
  Loader
} from 'semantic-ui-react';
import ReactQuill from 'react-quill';
import feathersConnect from './../../../providers/feathersConnect';

class AdminRichTextSectionView extends Component {

  constructor (props) {
    super(props);

    this.state = {
      richTextSectionId: null,
      text: '',
      loading: false,
      error: null,
      modules: {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{ 'align': [] }],
          ['link', 'image'],
          ['clean']
        ]
      }
    };

    this.PublicPagesSservice = this.props.feathers.service('/api/public-pages');
  }

  findRichTextSectionValue () {
    this.setState({
      error: null,
      loading: true,
      richTextSectionId: null,
      text: ''
    });

    this.PublicPagesSservice.find({
      query: {
        name: this.props.sectionName
      }
    })
      .then(response => {
        if (response) {
          this.setState({
            richTextSectionId: response.id,
            text: response.htmlValue,
            loading: false
          });
        } else {
          this.PublicPagesSservice.create({
            name: this.props.sectionName,
            htmlValue: ''
          })
            .then(page => {
              this.setState({
                loading: false
              });
              console.log(page);
            })
            .catch(error => {
              this.setState({
                loading: false
              });
              console.log(error);
            });
        }

      })
      .catch(error => {
        console.log(error);
        this.setState({
          loading: false
        });
      });
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.sectionName !== this.props.sectionName) {
      this.findRichTextSectionValue();
    }
  }

  handleTextChange (value) {
    this.setState({
      text: value
    });
  }

  saveText () {
    this.setState({
      loading: true
    });

    this.PublicPagesSservice.patch(this.state.richTextSectionId, {
      htmlValue: this.state.text
    })
      .then(response => {
        this.setState({
          loading: false
        });
        console.log(response);
      })
      .catch(error => {
        console.log(error);
        this.setState({
          loading: false
        });
      });
  }

  componentDidMount () {
    this.findRichTextSectionValue();
  }

  render () {
    let {
      loading,
      error,
      text,
      modules,
      formats
    } = this.state;

    if (loading) {
      return <Loader active inline="centered" content="Cargando Contenido"/>;
    }

    return (
      <div
        style={{ height: 546 }} >
        <Button size="mini" floated="right" primary content="Guardar" onClick={this.saveText.bind(this)} />
        <ReactQuill
          style={{
            height: 500
          }}
          modules={modules}
          value={text}
          onChange={this.handleTextChange.bind(this)} />
      </div>
    );
  }

}

export default feathersConnect(AdminRichTextSectionView);


// WEBPACK FOOTER //
// ./client/components/pages/public-pages/AdminRichTextSection.js